import styled from 'styled-components';

import { StyledFlex } from '@dreryk/react-components';

export const StyledMedicalProfileHeader = styled(StyledFlex)`
   margin-left: 16px;
`;

StyledMedicalProfileHeader.displayName = 'StyledMedicalProfileHeader';
